import React from 'react';
import { createPortal } from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CalendarPortal = ({ children }) => createPortal(
  <div className="app-calendar-portal">{children}</div>,
  document.body,
);

export default function DatePickerField({ id, selected, onChange, placeholder, ...props }) {
  return (
    <DatePicker
      id={id}
      selected={selected}
      onChange={onChange}
      placeholderText={placeholder}
      className="form-control app-date-control"
      wrapperClassName="app-datepicker-wrapper"
      calendarClassName="app-datepicker-calendar"
      popperClassName="app-datepicker-popper"
      popperContainer={CalendarPortal}
      popperPlacement="bottom-start"
      dateFormat="dd MMM yyyy"
      showPopperArrow
      isClearable
      {...props}
    />
  );
}
